import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';

import currency_arr from '../includes/common_arr/currency-arr.js';
import { useTheme } from "../includes/theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useModal } from '../providers/modal-provider.js';
import { useAuthData } from '../includes/auth-provider.js';


// modalData must have these attributes
// modalData = {
// 		apiCallback: function | undefined,
// 		modalCloseCallback: function | undefined,
// 		updateMode: boolean | undefined,
// 		currencyData: object | undefined,
// 		disabledFields: array | undefined,
//		page_name: string,
// }
export default function CurrencyModal() {
	const { theme, dropdownStyleDark } = useTheme()

	const { displayModal, modalData, closeModal, setModalData, setModalView } = useModal()

	const [selectedCurrencyCode, setSelectedCurrencyCode] = useState(null)
	const [currencySymbol, setCurrencySymbol] = useState("")
	const [selectedCurrencyDecimalPlace, setSelectedCurrencyDecimalPlace] = useState(null)
	const [selectedCurrencyFormat, setSelectedCurrencyFormat] = useState({ label: "12,34,567.89", value: "12,34,567.89" })

	const [currencySubmitButtonState, setCurrencySubmitButtonState] = useState(false)

	const { write, organization_id } = useAuthData(modalData.page_name)

	useEffect(() => {
		if (modalData && modalData.updateMode && modalData.currencyData) {
			setSelectedCurrencyCode({ label: modalData.currencyData.currency_code, value: modalData.currencyData.currency_code })
			setCurrencySymbol(modalData.currencyData.currency_symbol)
			setSelectedCurrencyDecimalPlace({ label: modalData.currencyData.decimal_place, value: modalData.currencyData.decimal_place })
			setSelectedCurrencyFormat({ label: modalData.currencyData.format, value: modalData.currencyData.format })
		}
	}, [modalData])


	const currencySubmit = () => {

		if (selectedCurrencyCode === null) {
			swal("Oops!", "Currency Code cannot be empty", "error");
			return
		}
		if (!currencySymbol.trim()) {
			swal("Oops!", "Currency Symbol cannot be empty", "error");
			return
		}
		if (selectedCurrencyDecimalPlace === null) {
			swal("Oops!", "Currency Decimal Place cannot be empty", "error");
			return
		}
		if (selectedCurrencyFormat === null) {
			swal("Oops!", "Currency Format cannot be empty", "error");
			return
		}

		var object = {};

		object.currency_code = selectedCurrencyCode.value
		object.currency_symbol = currencySymbol
		object.decimal_place = selectedCurrencyDecimalPlace.value
		object.format = selectedCurrencyFormat.value

		object.organization_id = organization_id;
		object.page_name = modalData.page_name;

		if (modalData.updateMode) {
			object.id = modalData.currencyData?.currency_id
		}

		// console.log(object);
		setCurrencySubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}

		let url = modalData.updateMode ? "update-currency" : "add-currency"

		axios.post(`${process.env.REACT_APP_SERVER_URL}/${url}`, object, headers).then((res) => {
			setCurrencySubmitButtonState(false)
			if (res.data.operation === "success") {
				swal("Great!", modalData.updateMode ? "Currency updated successfully!" : "Currency added successfully!", "success")
				handleCurrencyModalClose()

				modalData.apiCallback?.(res.data.info)
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const handleCurrencyModalClose = () => {
		modalData.modalCloseCallback?.()

		setSelectedCurrencyCode(null)
		setCurrencySymbol("")
		setSelectedCurrencyDecimalPlace(null)
		setSelectedCurrencyFormat(null)

		closeModal()
		setModalView(null)
        setModalData(null)
	}

	return (
		<Modal show={displayModal} onHide={() => { handleCurrencyModalClose() }} size="lg" centered>
			<Modal.Header>
				<Modal.Title>{modalData.updateMode ? "Update Currency" : "New Currency"}</Modal.Title>
				<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleCurrencyModalClose() }}>
					<span className="svg-icon svg-icon-1">
						<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
							<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
								<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
								<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
							</g>
						</svg>
					</span>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className='container'>
					<div className="row mb-4">
						<div className='col-12'>
							<label className="fs-5 fw-bold mb-2 required">Currency Code</label>
							<Select
								options={Object.keys(currency_arr.currency_arr[0]).map(x => { return { label: x, value: x } })}
								onChange={(val) => { setSelectedCurrencyCode(val); setCurrencySymbol(currency_arr.currency_arr[0][val.value].currency_symbol); }}
								value={selectedCurrencyCode}
								placeholder="--Choose a Currency--"
								isDisabled={modalData.disabledFields?.includes("currency_code") ?? false}
								styles={theme == 'dark' ? dropdownStyleDark : {}}
							/>
						</div>
					</div>
					<div className="row mb-4">
						<div className='col-12'>
							<label className="fs-6 fw-bold mb-2 required">Currency symbol</label>
							<input type="text" className="form-control form-control-solid" disabled={modalData.disabledFields?.includes("currency_symbol") ?? false} value={currencySymbol} onChange={(e) => { setCurrencySymbol(e.target.value) }} />
						</div>
					</div>
					<div className="row mb-4">
						<div className='col-12'>
							<label className="fs-5 fw-bold mb-2 required">Decimal Places</label>
							<Select
								options={[0, 2, 3].map(x => { return { label: x, value: x } })}
								onChange={(val) => { setSelectedCurrencyDecimalPlace(val) }}
								value={selectedCurrencyDecimalPlace}
								placeholder="--Choose Decimal Places--"
								isDisabled={modalData.disabledFields?.includes("decimal_places") ?? false}
								styles={theme == 'dark' ? dropdownStyleDark : {}}
							/>
						</div>
					</div>
					<div className="row mb-4">
						<div className='col-12'>
							<label className="fs-6 fw-bold mb-2 required">Format</label>
							<Select
								options={["12,34,567.89", "1,234,567.89", "1.234.567,89", "1 234 567,89"].map(x => { return { label: x, value: x } })}
								onChange={(e) => { setSelectedCurrencyFormat(e) }}
								value={selectedCurrencyFormat}
								placeholder="--Choose a Format--"
								isDisabled={modalData.disabledFields?.includes("format") ?? false}
								styles={theme == 'dark' ? dropdownStyleDark : {}}
							/>
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				{
					write &&
					<button className="btn btn-success rounded me-auto" data-kt-indicator={currencySubmitButtonState ? "on" : "off"} disabled={currencySubmitButtonState} onClick={() => { currencySubmit() }}>
						<span className="indicator-label">Save and Continue</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					</button>
				}
				<button className="btn btn-danger rounded" onClick={() => { handleCurrencyModalClose() }}>Close</button>
			</Modal.Footer>
		</Modal>
	);
};
